<template>
  <v-form
    :class="$style.host"
    @submit.prevent="submit"
  >
    <div :class="$style.subtitle">
      <span v-if="inCompanyExistsModal">Please enter your email.</span>
      <span v-else>We have verified your company as one of our distributors. Please enter your email.</span>
    </div>
    <distributor-error></distributor-error>
    <div :class="$style.input">
      <div :class="$style.label">Enter Your Email *</div>
      <v-text-field
        v-model="email"
        dense
        outlined
        :rules="[
          $rules.required($v.email),
          $rules.email($v.email),
          $rules.maxLength($v.email)
        ]"
      ></v-text-field>
    </div>

    <template v-if="inCompanyExistsModal">
      <v-btn
          color="primary"
          type="submit"
          :class="$style.inModal"
          :disabled="$v.$invalid || loading"
      >
        Confirm Email
      </v-btn>
    </template>

    <template v-else>
      <v-btn
          color="primary"
          type="submit"
          class="unr-button"
          :disabled="$v.$invalid || loading"
      >
        Confirm Email
      </v-btn>
      <v-btn
          color="primary"
          :class="['unr-button', $style.button]"
          @click="setDistributorCompany()"
      >
        Back
      </v-btn>
    </template>
  </v-form>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import {
  SET_DISTRIBUTOR_COMPANY,
  SET_DISTRIBUTOR_ERROR,
  SET_REGISTRATION_STEP,
  SET_USER_EMAIL,
  START_LOADING,
  STOP_LOADING,
  VERIFY_EMAIL,
} from '@/features/registration/store/modules/registration';
import { ServerValidationError } from '@/axios/exceptions';
import { email, maxLength, required } from 'vuelidate/lib/validators';
import DistributorError from '@/features/registration/components/distributor-error';

export default {
  name: 'DistributorFormEmail',
  components: {
    DistributorError,
  },
  props: {
    inCompanyExistsModal: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    email: '',
  }),
  validations: {
    email: { required, email, maxLength: maxLength(50) },
  },
  computed: mapState([
    'loading',
    'userEmail'
  ]),
  methods: {
    ...mapMutations({
      setUserEmail: SET_USER_EMAIL,
      setDistributorCompany: SET_DISTRIBUTOR_COMPANY,
      setDistributorError: SET_DISTRIBUTOR_ERROR,
      setRegistrationStep: SET_REGISTRATION_STEP,
      startLoading: START_LOADING,
      stopLoading: STOP_LOADING,
    }),
    ...mapActions({
      verifyEmail: VERIFY_EMAIL,
    }),
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.startLoading();
      try {
        await this.verifyEmail(this.email);
        this.$store.state.userEmail = this.email;
        this.setRegistrationStep();

        if (this.inCompanyExistsModal) {
          this.$emit('close', true);
        }
      } catch (error) {
        if (error instanceof ServerValidationError) {
          this.setDistributorError(error.message);
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: error.message,
          });
        }
      } finally {
        this.stopLoading();
      }
    },
  },
  mounted() {
    this.email = this.userEmail;
  }
};
</script>

<style lang="scss" module>
.host {

  .subtitle {
    margin-top: 15px;

    > span {
      @include font-open-sans-grey(16px, normal, 24px);
    }
  }

  .input {
    margin-top: 15px;
    text-align: left;
  }

  .label {
    @include font-open-sans-grey(16px, 600, 24px);
  }

  .button {

    &:not(:first-child) {
      margin-top: 15px;
    }
  }

  .inModal {
    margin: 25px 10px 0;
    width: 100%;
    max-width: 240px;
    min-height: 50px;

    > span {
      @include font-rubik-white(18px, 500, 22px, uppercase);
    }
  }
}
</style>
